module.exports = __webpack_public_path__ + "img/sv100.983fbcc4.svg";